import request from '@/utils/request'

// 办事类型
export function WeGetNWKindList(query) {
    return request({
        url: '/system/tnwkind/listByWeChat',
        method: 'get',
        params: query
    })
}

// 获取办事服务列表
export function WeGetNWMatterList(query) {
    return request({
        url: '/Network/WeGetNWMatterList',
        method: 'get',
        params: query
    })
}
//  获取工作详情
export function WeGetNWMatter(query) {
    return request({
        url: '/Network/WeGetNWMatter',
        method: 'get',
        params: query
    })
}
